import { useEffect } from 'react';
import { selectSetManualPayment, useQuoteStore } from '../../../stores';

const useManualPayment = (isManualPayment: boolean) => {
	const setManualPayment = useQuoteStore(selectSetManualPayment);

	useEffect(() => {
		setManualPayment(isManualPayment);

		return;
	}, []);
};

export default useManualPayment;
